/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Barcode_Holder_Deactivate_ForbiddenInputs */

const vi_error_barcode_holder_deactivate_forbidden = /** @type {(inputs: Error_Barcode_Holder_Deactivate_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn chưa có quyền sửa sản phẩm nên không ngừng hoạt động được sản phẩm đang giữ mã vạch. Nhờ quản trị viên cấp quyền hoặc dùng mã vạch khác.`)
};

/**

* @param {Error_Barcode_Holder_Deactivate_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_barcode_holder_deactivate_forbidden = /** @type {((inputs?: Error_Barcode_Holder_Deactivate_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Barcode_Holder_Deactivate_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_barcode_holder_deactivate_forbidden(inputs)
});